import {api} from 'app/services/api';
import {catchDataError} from 'app/helpers/apiHelpers';
import {changeHeaderText} from 'app/actions/headerActions';
import {updateHistory} from 'app/actions/historyActions';
import {updateHttpError} from 'app/components/error/ErrorHandlerActions';

const getData = (categorySlug, regionSlug) => {
  let apiUrl = `/about/${categorySlug}`;
  if (regionSlug) {
    apiUrl += `?region=${regionSlug}`;
  }
  return api.get(apiUrl);
};

function fetchingAboutDetail() {
  return {
    type: 'ABOUT_DETAIL_FETCHING',
  };
}

function updateAboutDetail(data) {
  return {
    type: 'ABOUT_DETAIL_UPDATE',
    data,
  };
}

function fetchAboutDetailSSR(categorySlug, regionSlug) {
  return async function (dispatch) {
    try {
      const response = await getData(categorySlug, regionSlug);
      dispatch(changeHeaderText({title: response.data.title}));
      dispatch(
        updateHistory('undefined', {
          store: 'AboutDetailPage',
          data: {data: response.data, isFetching: false, error: null},
        })
      );
    } catch (error) {
      const errorData = catchDataError(error);
      dispatch(updateHttpError(errorData));
    }
  };
}

function fetchAboutDetail(categorySlug, regionSlug, dispatchRedux) {
  return function (dispatch, state) {
    if (Object.keys(state.data).length) {
      dispatchRedux(changeHeaderText({title: state.data.title}));
      return;
    }
    dispatch(fetchingAboutDetail());
    return getData(categorySlug, regionSlug)
      .then(response => {
        dispatchRedux(changeHeaderText({title: response.data.title}));
        dispatch(updateAboutDetail(response.data));
      })
      .catch(function (error) {
        const errorData = catchDataError(error);
        dispatchRedux(updateHttpError(errorData));
      });
  };
}

export {fetchAboutDetailSSR, fetchAboutDetail};
